import { Box, Container } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";
import CustomText from "../../customComponents/customText";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";
import { Colors } from "../../assets/colors";

function Verticals() {
  let staticText = translation[language];
  let customImageWidth = { xs: 120, sm: 120, md: 150, lg: 180, xl: 140 };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <Box sx={styles.container}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <Box sx={{ marginTop: { xs: 6, sm: 9 } }}>
          <CustomText
            desc={staticText.verticals}
            fontFamily="Epilogue"
            colorvalue={Colors.andaihubTxt}
            style={{ ...styles.coreFeatureTxt }}
            title3
            fontWeight={400}
          />
        </Box>
        <Box
          sx={{
            width: "100%",
            justifyContent: "center",
            justifyItems: "center",
            alignItems: "center",
            display: "flex",
            paddingBottom: { xs: 3, sm: 10, md: 12, lg: 13 },
          }}
        >
          <Box
            sx={{
              width: { xs: '90%', sm: '90%', md: '88%', lg: '85%' },
              justifyContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              style={{ width: "100%" }}
            >
              <Box sx={styles.coreFeatureBox}>
                {staticText.verticalArray.map((item, index) => (
                  <motion.div key={index} variants={itemVariants}>
                    <Box
                      sx={{
                        ...styles.coreFeatureSubBox,
                       
                      }}
                    >
                      <Box
                        key={index}
                        component="img"
                        src={item.image}
                        alt={`Image ${index + 1}`}
                        sx={{
                          width: customImageWidth,
                          objectFit: "cover",
                          marginTop: { xs: 3, sm: 4, md: 5, lg: 6 }
                        }}
                      />

                      <CustomText
                        desc={item.head}
                        fontFamily="Epilogue"
                        colorvalue={Colors.coreFeatureHeadText}
                        style={{
                          ...styles.headText,
                          textAlign: "center",
                          marginTop: 2,
                        }}
                        h4
                        fontWeight={400}
                      />
                      <CustomText
                        desc={item.subHead}
                        fontFamily="Inter"
                        colorvalue={Colors.textColor}
                        style={{
                          ...styles.descText,
                          textAlign: "center",
                          marginTop: 0.6,
                        }}
                        p2
                        fontWeight={400}
                      />
                    </Box>
                  </motion.div>
                ))}
              </Box>
            </motion.div>
          </Box>
        </Box>
        {/* <Box sx={{ marginTop: 30 }}>
          <CustomText
            desc={staticText.ourClients}
            fontFamily="Epilogue"
            colorvalue={Colors.andaihubTxt}
            style={{ ...styles.coreFeatureTxt, marginBottom: 0 }}
            title3
            fontWeight={400}
          />
        </Box> */}
      </Container>
    </Box>
  );
}
const styles = {
  headText: {
    lineHeight: 1.4,
    fontStyle: "initial",
    fontSize: { xs: "1.4rem", sm: "1.3rem", md: "1.4rem", lg: "1.5rem", xl: "1.1rem" },
  },
  descText: {
    lineHeight: 1.5,
    fontStyle: "initial",
    fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem", lg: "1.3rem", xl: "1rem" },
  },
  coreFeatureSubBox: {
    objectFit: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    pl: { xs: 0, sm: 1.5, md: 2, lg: 2.5 },
    pr: { xs: 0, sm: 1.5, md: 2, lg: 2.5 },
  },
 
  coreFeatureBox: {
    display: { 
      xs: 'grid',  // For mobile devices
      sm: 'flex'   // For tablets and above
    },
    gridTemplateColumns: {
      xs: 'repeat(2, 1fr)', // Two columns for mobile
      sm: 'auto'            // Reset for larger screens
    },
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
  },
  container: {
    backgroundColor: Colors.white,
    paddingTop: { xs: 0, sm: 4, md: 5, lg: 6 },
    paddingBottom:0,
  },

  containerStyle: {
    backgroundColor: Colors.white,
  },
  coreFeatureTxt: {
    lineHeight: 1,
    fontStyle: "initial",
    textTransform: "none",
    textAlign: "center",
    backgroundColor: Colors.white,
    paddingBottom: { xs: 4, sm: 5, md: 7 },
  },
};

export default Verticals;
